import { render } from "./DetailScene.vue?vue&type=template&id=3f8d0b28"
import script from "./DetailScene.vue?vue&type=script&lang=js"
export * from "./DetailScene.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__